/**
 * @graphql cc
 */
import gql from 'graphql-tag';
import { useQuery } from 'react-apollo';

import type {
	useSpaceSettingsWebItemSectionsSpaceSettingsWebItemSectionsQuery as useSpaceSettingsWebItemSectionsSpaceSettingsWebItemSectionsQuery$data,
	useSpaceSettingsWebItemSectionsSpaceSettingsWebItemSectionsQueryVariables as useSpaceSettingsWebItemSectionsSpaceSettingsWebItemSectionsQuery$variables,
} from './__types__/useSpaceSettingsWebItemSectionsSpaceSettingsWebItemSectionsQuery';
import type { SpaceSettingsWebItemSectionsInjector } from './SpaceSettingsWebItemSectionsInjector';
import { useSpaceSettingsWebItemSectionsFromQuery } from './useSpaceSettingsWebItemSectionsFromQuery';

const useSpaceSettingsWebItemSectionsSpaceSettingsWebItemSectionsQuery = gql`
	query useSpaceSettingsWebItemSectionsSpaceSettingsWebItemSectionsQuery($spaceKey: String) {
		webItemSections(location: "system.space.tools", key: $spaceKey) {
			id
			label
			cacheKey
			items {
				id
				completeKey
				label
				url
				icon {
					path
				}
			}
		}
		space(key: $spaceKey) {
			alias
			id
			key
			currentUser {
				isAdmin
			}
		}
	}
`;
export type UseSpaceSettingsWebItemSectionsProps = {
	spaceAlias: string;
};

export type UseSpaceSettingsWebItemSectionsReturn = {
	loading: boolean;
	error: Error | undefined;
	webItemSections: ReturnType<SpaceSettingsWebItemSectionsInjector>;
};

export const useSpaceSettingsWebItemSections = ({
	spaceAlias,
}: UseSpaceSettingsWebItemSectionsProps): UseSpaceSettingsWebItemSectionsReturn => {
	const { data, loading, error } = useQuery<
		useSpaceSettingsWebItemSectionsSpaceSettingsWebItemSectionsQuery$data,
		useSpaceSettingsWebItemSectionsSpaceSettingsWebItemSectionsQuery$variables
	>(useSpaceSettingsWebItemSectionsSpaceSettingsWebItemSectionsQuery, {
		variables: {
			spaceKey: spaceAlias,
		},
	});
	const webItemSections = useSpaceSettingsWebItemSectionsFromQuery(data);
	return {
		loading,
		error,
		webItemSections: !loading && !error ? webItemSections : undefined,
	};
};
